import React, { useState } from 'react'
import Gtm from '../../../utils/gtm'

import Container from './Container'
import { useStyles } from './Panel.styles'
import { benefitsContent } from './enums/benefits'
import { loggingEnabled } from '../../../utils/logging'

export const Panel = () => {
  const classes = useStyles()
  const gtm = new Gtm(loggingEnabled)
  const [formStatus, setFormStatus] = useState('in-progress')
  const [newMemberNumber, setNewMemberNumber] = useState('')
  const isPromoForm = false
  const isPanelForm = true

  const closeFormPanel = () => {
    document.getElementById('form-panel').classList.remove('is-active')
    document.body.style.overflow = 'auto'
  }

  return (
    <div id="form-panel" className={classes.formPanel} hidden>
      <div className={classes.formPanelInner}>
        <div id="blue-chip-form-header" className={classes.formPanelHeader}>
          <div className={classes.panelClose} onClick={closeFormPanel}></div>

          {formStatus != 'complete' && (
            <div className={classes.promoIntroduction}>
              <h2>
                <span>Save 15&#37;</span>
                on every rental&#42;
              </h2>
              <p>when you join Thrifty Blue Chip Member Program</p>
            </div>
          )}

          {formStatus === 'complete' && (
            <div className={classes.promoCompletion}>
              <h2>
                <span>Congratulations!</span>
                You&#39;re now a Blue Chip member.
              </h2>
              <p>You can now save 15&#37; on every Thrifty booking and heaps more perks!</p>
              <p>
                Your membership number is: <br />
                {newMemberNumber != '' ? newMemberNumber : 'Check your email'}
              </p>
              <button hidden>Save for booking???</button>
            </div>
          )}
        </div>

        <div id="blue-chip-form-container" className={classes.formPanelMain}>
          <Container
            isPanelForm={isPanelForm}
            isPromoForm={isPromoForm}
            setNewMemberNumber={setNewMemberNumber}
            setFormStatus={setFormStatus}
          />
        </div>

        {benefitsContent && (
          <div className={classes.formPanelFooter}>
            <div className={classes.benefitsContainer}>
              <h2 className={classes.benefitsTitle}>{benefitsContent.title}</h2>

              <div className={classes.benefitsItems}>
                {benefitsContent.benfits.map((item, idx) => (
                  <div className={classes.benefitsItem} key={`benefit-item-${idx}`}>
                    <div className={classes.benefitsItemImage}>
                      <img src={item.img} />
                    </div>

                    <div
                      className={classes.benefitsItemTitle}
                      dangerouslySetInnerHTML={item.title}
                    ></div>

                    <div className={classes.benefitsItemDetails}>{item.details}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default Panel
